// extracted by mini-css-extract-plugin
export default {"select":"StatusSelector_select__DCuxE"};